module.exports = __webpack_public_path__ + "fonts/LineIconsPro Light.cb1128f.woff";